<template>
  <div id="app">
    <CoolLightBox
      :items="getImages"
      :index="index"
      :closeOnClickOutsideMobile="true"
      @close="index = null"
    >
    </CoolLightBox>
    <div class="cp-px-2">
      <div
        class="images-wrapper cp-flex cp-flex-wrap cp-flex-row -cp-mx-4 cp-cursor-pointer cp-overflow-hidden"
      >
        <div
          class="cp-w-1/2 md:cp-w-1/4 cp-px-2 cp-h-48 cp-bg-cover cp-bg-center cp-bg-no-repeat cp-border-solid cp-border-8 cp-border-white"
          v-for="(image, imageIndex) in getImages"
          :key="imageIndex"
          @click="index = imageIndex"
          v-lazy:background-image="image.src"
        ></div>
      </div>
    </div>
  </div>
</template>

<style>
img[lazy="loaded"] {
  opacity: 0;
  animation-name: fadein;
  animation-duration: 3s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-direction: normal;
  animation-timing-function: ease-out;
  @keyframes fadein {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
.cool-lightbox-caption h6 {
  color: #fff;
}
</style>

<script>
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

export default {
  data() {
    return {
      index: null,
    };
  },
  components: {
    CoolLightBox,
  },
  props: {
    loadedimages: String,
  },
  computed: {
    getImages() {
      var images = JSON.parse(this.loadedimages);
      return images;
    },
  },
  mounted() {},
};
</script>
